<template>
    <account :user="$store.state.user" />
</template>

<script>
import Account from './Account.vue'
export default {
    name: 'zoezi-myaccount',

    zoezi: {
        title: 'My account',
        icon: 'mdi-account-details'
    },

    components: {
        Account
    }
}
</script>
